export const SPY_CATEGORIES = ['Лёгкие', 'Средние', 'Сложные', 'Фильмы', 'Игры', 'Сериалы'] as const;

export const CUSTOM_CATEGORY = 'Свои';

export interface SpyLocation {
    name: string;
    category?: string;
    custom?: boolean;
    ai?: boolean;
}
